import { defineMessages } from "react-intl";

export const messages = defineMessages({
    noEngagementHeading: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.heading",
        defaultMessage: "A migration project hasn’t started yet",
        description:
            "Heading for error banner displayed when there is no engagement project"
    },
    noEngagementDescription: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.description",
        defaultMessage:
            "The FastShift team will engage with the customer to create a detailed migration project, defining tasks and timelines. Once that work has kicked off, it will be visible on this page.",
        description:
            "Description for error banner displayed when there is no engagement project"
    },
    noEngagementGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-engagement.graphic-alt-text",
        defaultMessage: "Blueprint Graphic",
        description:
            "Alt Text for the blueprint vector graphic displayed when a no-engagement-project error occurs"
    },
    noAccessHeading: {
        id: "fastshift.migrations-management-page.error-display.no-access.heading",
        defaultMessage:
            "You do not have permissions to view the migration project",
        description:
            "Heading for error banner displayed when customer does not have permissions to access the existing engagement project"
    },
    noAccessDescription: {
        id: "fastshift.migrations-management-page.error-display.no-access.description",
        defaultMessage:
            "If you believe you should be able to see the content of the migration project, contact your FastShift Champion.",
        description:
            "Description for error banner displayed when customer does not have permissions to access the existing  engagement project"
    },
    noAccessGraphicAltText: {
        id: "fastshift.migrations-management-page.error-display.no-access.graphic-alt-text",
        defaultMessage: "Padlock Graphic",
        description:
            "Alt Text for the generic error vector graphic displayed when a no-access error occurs"
    },
    userAccountNotProvisionedHeading: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.heading",
        defaultMessage: "Get started with your project",
        description:
            "Heading for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedDescription: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.description",
        defaultMessage:
            "To get access to a project with your migration plan, you need to first log in so we can set up your account.",
        description:
            "Description for error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    },
    userAccountNotProvisionedButton: {
        id: "fastshift.migrations-management-page.error-display.userAccountNotProvisioned.button",
        defaultMessage: "Log In",
        description:
            "Log In Button Text on the error banner displayed when the user's account has not been provisioned in as-a-team site yet"
    }
});
